import React from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import CustomerDetails from "components/priceQuote/quoteTabs/customerDetails";
import QuoteDetails from "components/priceQuote/quoteTabs/quoteDetails";
import QuoteSummary from "components/priceQuote/quoteTabs/quoteSummary";
import PdfOptions from "components/priceQuote/quoteTabs/pdfOptions";
import DeliverQuote from "components/priceQuote/quoteTabs/deliverQuote";
import { api } from "store/slices/api";
import "./style.scss";

const QuoteTabs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { quoteId } = useParams();
  const { terrCcn, storeCcn } = useSelector((state) => state.loggedInUser);
  const { data: quoteFields = {} } = api.useGetPriceQuoteQuery(quoteId);
  const { territory, storeNumber } = quoteFields;

  const territoryAccess =
    (territory === terrCcn && territory !== "800100") ||
    (storeCcn === storeNumber && quoteFields.punchoutPublished !== true);

  return (
    <div className="p-4 pt-2 border-top-0" style={{ border: "1px solid #d1d1d1", borderRadius: "0 0 8px 8px" }}>
      <Tabs transition={false} activeKey={location.hash} onSelect={(key) => navigate(`/priceQuote/${quoteId}${key}`)}>
        <Tab eventKey="#customer-details" title="Customer Details" mountOnEnter>
          <CustomerDetails {...{ territoryAccess }} />
        </Tab>
        <Tab eventKey="#quote-details" title="Quote Details" mountOnEnter>
          <QuoteDetails {...{ territoryAccess }} />
        </Tab>
        <Tab eventKey="#quote-summary" title="Quote Summary" mountOnEnter>
          <QuoteSummary {...{ territoryAccess }} />
        </Tab>
        <Tab eventKey="#pdf-options" title="PDF Options" mountOnEnter>
          <PdfOptions {...{ territoryAccess }} />
        </Tab>
        <Tab eventKey="#deliver-quote" title="Deliver Quote" mountOnEnter>
          <DeliverQuote {...{ territoryAccess }} />
        </Tab>
      </Tabs>
    </div>
  );
};

export default QuoteTabs;
